import React from 'react';
import { FaUserPlus, FaEnvelope } from 'react-icons/fa';

const Affiliates = () => {
  return (
    <div className="w-full bg-white shadow-md p-4 md:p-6 rounded-md">
      <h3 className="text-lg font-semibold mb-4 lg:text-center">Affiliates</h3>
      <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 mb-4 items-center justify-center">
        <button className="flex items-center justify-center space-x-2 w-full sm:w-auto bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-300">
          <FaUserPlus />
          <span className="text-center">Add Affiliate</span>
        </button>
        <button className="flex items-center justify-center space-x-2 w-full sm:w-auto bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-300">
          <FaEnvelope />
          <span className="text-center">Invite Affiliate</span>
          
        </button>
      </div>
    </div>
  );
};

export default Affiliates;


// import React from 'react';
// import { FaUserPlus, FaEnvelope } from 'react-icons/fa';

// const Affiliates = () => {
//   return (
//     <div className="w-full bg-white shadow-md p-4 md:p-6 rounded-md">
//       <h3 className="text-lg font-semibold mb-4 lg:text-center">Affiliates</h3>
//       <div className="flex space-x-4 mb-4 lg:item-center lg:justify-center ">
//         <button className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-300">
//           <FaUserPlus />
//           <span>Add Affiliate</span>
//         </button>
//         <button className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-300">
//           <FaEnvelope />
//           <span>Invite Affiliate</span>
//         </button>
//       </div>
      
     
//     </div>
//   );
// };

// export default Affiliates;


